import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import Image from "next/image";
import Drawer from "rc-drawer";
import "rc-drawer/assets/index.css";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import RFWheel from "@/components/RFWheel";
import IconFont from "@/components/IconFont";
import debounce from "lodash/debounce";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";

interface SpinWheelProps {
  visible: boolean;
  opportunities: number;
  onClose?: () => void;
  onEnd: (prize: number) => void;
  onSpin: () => void;
}

function SpinWheel(
  { visible, opportunities, onClose, onSpin, onEnd }: SpinWheelProps,
  ref: React.ForwardedRef<any>
) {
  const { t } = useTranslation("activities");
  const wheelRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    wheel: wheelRef,
  }));

  const [openDrawer, setOpenDrawer] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [ableClose, setAbleClose] = useState(true);

  const handleClose = () => {
    setOpenDrawer(false);
    onClose && onClose();
  };

  useEffect(() => {
    setOpenDrawer(visible);
  }, [visible]);

  return <>
    <Drawer
      open={openDrawer}
      maskClosable={ableClose}
      placement="bottom"
      onClose={handleClose}
      
      className={styles.innerDrawer}
      maskStyle={{
        background: "#1A181F",
        opacity: 0.8,
      }}
    >
      <div className={styles.spinWrapper}>
        <div className={styles.spinInner}>
          <Image
            src={getFullWebCdnUrl("/pulling-new/wheel-bg-1.png")}
            alt=""
            width={287}
            height={294}
            priority={true}
            sizes="100vw"
            style={{
              width: "100%",
              height: "auto"
            }} />

          <div className={styles.spinWheel}>
            <RFWheel
              ref={wheelRef}
              onEnd={(e) => {
                setShowResult(true);
                setAbleClose(true);
                setTimeout(() => {
                  onEnd(e);
                }, 1000);
              }}
              onStart={() => {
                setShowResult(false);
                setAbleClose(false);
              }}
            />
            {showResult && <div className={styles.point}></div>}
          </div>
          <div className={styles.spinPointer} onClick={debounce(onSpin, 300)}>
            <div>GO</div>
            <span>
              {opportunities} {opportunities > 1 ? t("chances") : t("chance")}
            </span>
          </div>
          <IconFont type="a-bianzu25" className={styles.spinArrow} />
        </div>
      </div>
    </Drawer>
  </>;
}

export default React.forwardRef(SpinWheel);
